module.exports = __webpack_public_path__ + "static/img/qian.471def2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/qian.png
// module id = UEY8
// module chunks = 128